webpackJsonp([10],{

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(832),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20b9ab72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ls = __webpack_require__(27);
var configurations = __webpack_require__(33);
var cloudinarySettings = configurations.cloudinary_settings;
var cloud_name = configurations.cloudinary_cloudName;
var upload_preset = configurations.cloudinary_preset;

/* harmony default export */ __webpack_exports__["a"] = ({
  //
  data: function data() {
    return {
      uploadedImgUrl: ''
    };
  },

  //
  created: function created() {
    // two set interval cz -> a page can have 2 search.
    // 1
    setInterval(function () {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast != window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage && window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast = window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage;

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage
        });

        console.log("[CALLING SEARCH.........]");
      } else {}
    }, 500);
    //
    // 2
    setInterval(function () {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 != window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage && window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 = window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage;

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage
        });

        console.log("[CALLING SEARCH.........]");
      } else {}
    }, 500);
    //
    var str = ls.get('thumbnailImgUrl');
    var id = str.split('/')[str.split('/').length - 1];
    this.uploadedImgUrl = 'https://res.cloudinary.com/' + cloud_name + '/image/upload/w_600,h_400,c_fill,' + cloudinarySettings + '/' + upload_preset + '/' + id;
    console.log("[uploadedImgUrl] => ", this.uploadedImgUrl);
    //
  }
});

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_uploadImage__ = __webpack_require__(544);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//

//
/* harmony default export */ __webpack_exports__["default"] = ({
  //
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_uploadImage__["a" /* default */]],
  //
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['getMarkerPosition', 'getCurrentGeoLocation', 'skip_uploadImage_3'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['showHideMapInput', 'showMap', 'addressDetails'])),
  created: function created() {
    window.thisOfMap = this;
  },
  mounted: function mounted() {
    window.thisOfVueComp = this;
    // now, we want address, like shopnest.
    // this.$store.commit('getMarkerOnCurrentLoc')
    this.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3 = this.$route.query.geoLocIsAvailable;
    this.$store.state.uploadImage_3.geohash_uploadImage_3 = this.$route.query.geohash;
    //console.log('UPLOAD 1',this.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3)
    //console.log('UPLOAD 2',this.$store.state.uploadImage_3.geohash_uploadImage_3)
  }
  //

});

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, "#myMap[data-v-20b9ab72]{height:70vh;width:100%}#pac-input-1[data-v-20b9ab72]{background-color:#fff;font-family:Roboto;font-size:15px;font-weight:200;margin-left:12px;padding:0 11px 0 13px;text-overflow:ellipsis;width:200px;height:35px}.true[data-v-20b9ab72]{visibility:visible}.false[data-v-20b9ab72]{visibility:hidden}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/uploadImage/uploadImage_3.vue"],"names":[],"mappings":"AACA,wBACE,YAAY,AACZ,UAAY,CACb,AACD,8BACE,sBAAuB,AACvB,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,sBAAuB,AACvB,uBAAwB,AACxB,YAAa,AACb,WAAa,CACd,AACD,uBACE,kBAAoB,CACrB,AACD,wBACE,iBAAmB,CACpB","file":"uploadImage_3.vue","sourcesContent":["\n#myMap[data-v-20b9ab72] {\n  height:70vh;\n  width: 100%;\n}\n#pac-input-1[data-v-20b9ab72] {\n  background-color: #fff;\n  font-family: Roboto;\n  font-size: 15px;\n  font-weight: 200;\n  margin-left: 12px;\n  padding: 0 11px 0 13px;\n  text-overflow: ellipsis;\n  width: 200px;\n  height: 35px;\n}\n.true[data-v-20b9ab72]{\n  visibility: visible;\n}\n.false[data-v-20b9ab72]{\n  visibility: hidden;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(664);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("2c8620eb", content, true, {});

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Step 3/5")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.uploadedImgUrl),
      expression: "uploadedImgUrl"
    }],
    attrs: {
      "height": "100",
      "width": "100"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n\n  from previous route => " + _vm._s(_vm.$route.query) + " "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "div-width-100"
  }, [_c('div', [_c('input', {
    attrs: {
      "id": "pac-input-1",
      "type": "text",
      "placeholder": "Search Box"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "blue--text",
    attrs: {
      "id": "locBut"
    },
    on: {
      "click": _vm.getCurrentGeoLocation
    },
    nativeOn: {
      "click": function($event) {
        _vm.$store.state.uploadImage_3.getCenter = true
      }
    }
  }, [_c('v-icon', [_vm._v("location_searching")])], 1), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.getMarkerPosition({ // this location
          url: _vm.$route.query.url,
          resourceType: _vm.$route.query.resourceType,
          publicId: _vm.$route.query.publicId,
          //
          createdAt: _vm.$route.query.createdAt,
          //
          caption: _vm.$route.query.caption,
          emotionalAppeal: JSON.parse(_vm.$route.query.emotionalAppeal)
        })
      }
    }
  }, [_vm._v("\n        Select Marker Location\n      ")])])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.skip_uploadImage_3({ // skip //empty location
          url: _vm.$route.query.url,
          resourceType: _vm.$route.query.resourceType,
          publicId: _vm.$route.query.publicId,
          //
          createdAt: _vm.$route.query.createdAt,
          //
          caption: _vm.$route.query.caption,
          emotionalAppeal: JSON.parse(_vm.$route.query.emotionalAppeal)
        })
      }
    }
  }, [_vm._v("\n    skip\n  ")])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/10.10a91ff3fe931f1e7c9b.js